import { useCallback } from 'react';
export const useAnalyticsReportClicks = ({ reportBiOnClick, onClick: propsOnClick, }) => {
    return useCallback(event => {
        reportBiOnClick === null || reportBiOnClick === void 0 ? void 0 : reportBiOnClick(event);
        propsOnClick === null || propsOnClick === void 0 ? void 0 : propsOnClick(event);
    }, [reportBiOnClick, propsOnClick]);
};
//# sourceMappingURL=hooks.js.map